var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{staticClass:"hamburger",class:{'is-active':_vm.isActive},attrs:{"src":require("../../assets/image/index/aa.png"),"width":"64","height":"64"},on:{"click":_vm.toggleClick}})])}
var staticRenderFns = []

export { render, staticRenderFns }